import { render, staticRenderFns } from "./StatementPosting.vue?vue&type=template&id=0d705fc2"
import script from "./StatementPosting.vue?vue&type=script&lang=js"
export * from "./StatementPosting.vue?vue&type=script&lang=js"
import style0 from "./StatementPosting.vue?vue&type=style&index=0&id=0d705fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports